<div class="modal-header">
  <h4 class="modal-title">{{ 'BROUTER_MAP.LOAD.TITLE' | translate }}</h4>
  <button
    type="button"
    class="btn btn-circle btn-ghost element-cancel"
    [attr.aria-label]="'SHARED.CLOSE' | translate"
    (click)="closed.emit()"
  ></button>
</div>

<div class="modal-body">
  <p class="text-secondary">
    {{ 'BROUTER_MAP.LOAD.DESCRIPTION' | translate: { count: maxWaypoints } }}
  </p>

  <!-- Upload is disabled: the file is parsed in the browser, never sent to a server. -->
  <si-file-uploader
    accept=".gpx,.kml,.geojson,.json"
    [maxFiles]="1"
    [maxFileSize]="maxFileSize"
    [disableUpload]="true"
    (filesChanges)="onFilesChanged($event)"
  />

  @if (error(); as message) {
    <p class="text-danger mt-5 mb-0">{{ message }}</p>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="closed.emit()">
    {{ 'SHARED.CANCEL' | translate }}
  </button>
</div>
